import React from "react";
import SubmittedAgreement from "../sumitted_agreement/SubmittedAgreement";

const FinalRevisedAgreement = () => {
  const fileStatus = 13;
  const applicationPath = {
    copyright: "/admin/final-revised-document-copyright",
    agreement: "/admin/final-revised-document-agreement",
  };
  const detailsRoute = "/admin/submitted-agreement-details-verify";
  const pageTitle = "সংশোধিত নথি";
  return (
    <SubmittedAgreement
      fileStatus={fileStatus}
      applicationPath={applicationPath}
      detailsRoute={detailsRoute}
      pageTitle={pageTitle}
    />
  );
};

export default FinalRevisedAgreement;
